export default __webpack_public_path__ + "static/media/marketing_illustration.ee1ac731.svg";